export const theme = {
  token: {
    colorPrimary: "#1679AB",
  },
};
